import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, SummaryStepData } from '@packages/shared/core/quiz/entities';

type SummaryQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const SummaryQuizStep = ({ id, renderQuizScreen }: SummaryQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData } = useQuizStep(id);

  if (!stepData) {
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goNext = async () => next();
  const goBack = async () => back();

  return (
    <>
      {renderQuizScreen({
        goNext,
        goBack,
        ...(stepData as SummaryStepData),
      })}
    </>
  );
};

export default SummaryQuizStep;
